module.exports = __webpack_public_path__ + "img/jdpProgram1.71c21296.jpg";